import type {
  DeploymentUnitResourceItemBffV2Api,
  DeploymentUnitResourceListResponseBffV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { DeploymentTargetDeviceResourceById } from '@ingenico/react-ui';
import { sum, values } from 'lodash-es';
import type { SearchFilter, SearchRequest } from '../../../models/common.model';
import type {
  DeploymentUnitsStatusCount,
  PaginatedDeploymentUnitResourceList,
} from '../../../models/deployment/deploymentUnitList.model';
import { mapDeploymentUnitResponse } from './deploymentUnitById.mapper';

export function mapDeploymentUnitsResponse(
  response: DeploymentUnitResourceListResponseBffV2Api,
): PaginatedDeploymentUnitResourceList {
  return {
    data: mapDeploymentUnitResourceListResponseBffV2ApiToPaginatedDeploymentUnitResourceList(response.data),
    pagination: response.pagination,
  };
}

function mapDeploymentUnitResourceListResponseBffV2ApiToPaginatedDeploymentUnitResourceList(
  units: DeploymentUnitResourceItemBffV2Api[],
): DeploymentTargetDeviceResourceById[] {
  return units.map(mapDeploymentUnitResponse);
}

export function buildDeploymentUnitRequestBody(deploymentId: string, status: string): SearchRequest {
  const filters: SearchFilter[] = [
    {
      filterType: 'string',
      name: 'deploymentUnit.deploymentRequestId',
      operator: 'equals',
      value: deploymentId,
    },
  ];

  filters.push({
    filterType: 'array',
    name: 'deploymentUnit.status',
    operator: 'in',
    value: status,
  });

  return {
    filters,
    sort: {},
  };
}

export function mapMultipleDeploymentUnits(
  responses: DeploymentUnitResourceListResponseBffV2Api[],
): DeploymentUnitsStatusCount {
  const [completed, pending, canceled, failed] = responses;
  const counts = {
    completed: completed.pagination.totalResults ?? 0,
    canceled: canceled.pagination.totalResults ?? 0,
    failed: failed.pagination.totalResults ?? 0,
    pending: pending.pagination.totalResults ?? 0,
  };

  return {
    ...counts,
    total: sum(values(counts)),
  };
}
